exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar[data-v-13ef610b] {\n  width: 100px;\n  height: 100px;\n  display: block;\n  position: relative;\n  background: rgb(217, 236, 255);\n  border-radius: 6px;\n}\n.avatar:hover .operate[data-v-13ef610b] {\n  visibility: visible;\n}\n.operate[data-v-13ef610b] {\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  z-index: 100;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background-color: #909399;\n}", ""]);

// exports
